const e = () => {
}, n = typeof globalThis < "u" && typeof navigator < "u" && typeof document < "u";
export {
  n as i,
  e as n
};
//# sourceMappingURL=const-BlLLRlwg.mjs.map
